import React, { Component } from 'react';

import registerConstants from '../../register/constants/register-constants';
import CommissionSchemeOther from './commission-scheme-other';
import CommissionSchemeIb from './commission-scheme-ib';
import CommissionSchemeIfs from './commission-scheme-ifs';

class CommissionSchemeNonAffiliate extends Component {
  renderCommissionScheme = () => {
    const { profile } = this.props;

    if (!profile || !profile.additional_data) {
      return null;
    }

    switch (profile.user_type) {
      case registerConstants.user_types.ib:
        return <CommissionSchemeIb profile={profile} />;
      case registerConstants.user_types.ifs_type:
        return <CommissionSchemeIfs profile={profile} />;
      default:
        return <CommissionSchemeOther profile={profile} />;
    }
  };

  render() {
    return <div className="commission-scheme-non-affiliate">{this.renderCommissionScheme()}</div>;
  }
}

export default CommissionSchemeNonAffiliate;



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/commission-scheme-non-affiliate.js